// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import { computed } from 'vue'
import hybridPage from '@/lib/hybridPage'
import {
	GaGeneralPageName,
	createGAEvent,
	GaGeneralEvent,
} from '@/assets/ts/customEvent'
import { setCurrentGaPageName, getCurrentGaPageName } from '@/lib/utils'
import YahooLanding from '@/pages/yahoo-landing/components/_YahooLanding.vue'
import PageBreadCrumb from '@/components/PageBreadCrumb.vue'
import { getSiteBaseUrl } from '@/lib/siteBaseUrl'
import getRedirectSeoLink, { getPageUrl } from '@/lib/getSeoRedirect'

hybridPage()

createApp({
	name: 'Yahoo Landing Page',
	components: {
		YahooLanding,
		PageBreadCrumb,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.YahooLanding)
		createGAEvent(GaGeneralEvent.PageLoad, {
			page_name: getCurrentGaPageName(),
		})

		const { pageContent } = window

		const breadcrumbs = computed(() => [
			{
				displayName: window.pageContent.breadcrumbs?.index || '',
				categoryId: 'home',
				link: getSiteBaseUrl(),
			},
			{
				displayName: window.pageContent.breadcrumbs?.shopping || '',
				categoryId: 'shopping',
				link: `${getSiteBaseUrl()}/${getRedirectSeoLink('proxyShopping')}`,
			},
			{
				displayName: window.pageContent.breadcrumbs?.YahooLanding || '',
				categoryId: 'YahooLanding',
				link: getPageUrl(GaGeneralPageName.YahooLanding),
			},
		])

		return {
			pageContent,
			breadcrumbs,
		}
	},
}).mount('#bsMain')
